import "../body.css";
import Header from "../header";
import Footer from "../footer";

import React, { useEffect } from "react";

function Blog() {
    useEffect(() => {
        document.title = "Josiah Swanson - Blog";
    }, []);
    return (
        <>
            <section>
                <p>May 23, 2022</p>
                <p>A good quote by A.W. Pink:</p>
                <p>
                    "Here is a solid comfort. Human nature cannot be relied upon; but God
                    can! However unstable I may be, however fickle my friends may prove,
                    God changes not."
                </p>
                <p>
                    <br></br>
                </p>

                <p>May 22, 2022</p>
                <p>
                    <br></br>
                </p>
                <p>
                    Recently, I was in a Bible study where we were talking about God's{" "}
                    <span title="def: the state of not changing or being unable to be changed">
                        immutability
                    </span>
                    .
                </p>
                <p>
                    As James 1:17 goes, "every good thing given and every perfect gift is
                    from above, coming down from the Father of lights, with whom there is
                    no variation or shifting shadow."
                </p>
                <p>
                    Together, we wondered whether James could have been thinking of the
                    starry nighttime sky when he penned these words. Being a star-gazer
                    myself, I decided to write this poem.
                </p>
                <p>
                    <br></br>
                </p>
                <p className="centeredp">
                    Bright stars shone in ages past<br></br>
                    The same stars shine today<br></br>
                    These heavenly lights were made to last<br></br>
                    And will not quickly fade away?
                </p>
                <p>
                    <br></br>
                </p>
                <p className="centeredp">
                    Why should I then doubt <span>God's</span> state<br></br>
                    When moral things remain the same?<br></br>I will gladly trust my fate
                    <br></br>
                    To Him Who cannot change His name
                </p>
                <p>
                    <br></br>
                </p>
                <p>JDS</p>
            </section>
        </>
    );
}

export default Blog;
